import script from "./DirectoryHomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectoryHomePage.vue?vue&type=script&setup=true&lang=js"

import "./DirectoryHomePage.vue?vue&type=style&index=0&id=aa2bd52a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa2bd52a"]])

export default __exports__